import React, { useEffect } from "react";
import { useTour } from "../components/ui/TourContext";
import AppRoutes from "./app-route";

function AuthenticatedApp({ props, isLoading, path, clients, emps, appointments }) {
  const { startTour } = useTour();

  useEffect(() => {
    if (isLoading) return;
    if (path !== "/dashboard") return;

    const blockedRoutes = [
      "/",
      "/login",
      "/register",
      "/verify-email-sent",
      "/verify-email",
      "/verify-new-email",
      "/updatepassword",
      "/forgotpassword",
    ];
    if (blockedRoutes.includes(path)) return;

    const hasClients = Array.isArray(clients) && clients.length > 0;
    const hasEmployees = Array.isArray(emps) && emps.length > 0;
    const hasAppointments = Array.isArray(appointments) && appointments.length > 0;

    const hasSeenTour = localStorage.getItem("hasSeenTour");

    if (hasClients || hasEmployees || hasAppointments) {
      if (!hasSeenTour) {
        localStorage.setItem("hasSeenTour", "true");
      }
      return;
    } else {
      if (!hasSeenTour) {
        localStorage.setItem("startTour", "getting-started");
        startTour("getting-started");
      }
    }
  }, [isLoading, path, clients, appointments, emps, startTour]);

  return <AppRoutes {...props} isLoading={isLoading} />;
}

export default AuthenticatedApp;